import React from "react";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import styles from "../styles/staticPages.js";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import Parallax from "components/Parallax/Parallax";
import HeaderLinks from "components/Header/HeaderLinks.js";


const useStyles = makeStyles(styles);

export default function TermCondition(props) {
  const classes = useStyles();
  const { ...rest } = props;

  return (
    <div >
      <Header
        color="transparent"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg")} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <br />
          <h2 style={{ textAlign: "left", marginTop: "30px", color: "#383838" }}>
            Termos e Condições de Uso
          </h2>
          <p className={classes.description}>
            Agradecemos por utilizar nossos serviços de intermediação, por meio de aplicativo, voltados à solicitação de transporte individual de passageiros e entregas. Por favor, leia atentamente os termos a seguir antes de utilizar nossa plataforma.
          </p>
          <br />
          <p className={classes.description}><strong>Aceitação dos Termos</strong></p>
          <p className={classes.description}>
            Ao acessar, baixar ou utilizar nossos serviços, o usuário declara ter lido, compreendido e aceitado integralmente estes Termos e Condições de Uso. Caso não concorde com qualquer cláusula, não deverá utilizar a plataforma.
          </p>
          <p className={classes.description}><strong>Elegibilidade</strong></p>
          <p className={classes.description}>
            O uso da plataforma está condicionado à capacidade civil plena. É necessário ter no mínimo 18 (dezoito) anos de idade. Ao utilizar os serviços, o usuário declara, sob as penas da lei, possuir essa idade ou estar legalmente autorizado.
          </p>
          <p className={classes.description}><strong>Descrição dos Serviços</strong></p>
          <p className={classes.description}>
            A plataforma atua como intermediadora entre usuários e prestadores autônomos de serviços de transporte e/ou entrega. Não realizamos os serviços diretamente e não somos empregadores dos motoristas ou entregadores cadastrados.
          </p>
          <p className={classes.description}><strong>Formas de Pagamento</strong></p>
          <p className={classes.description}>
            Os pagamentos pelos serviços solicitados devem ser realizados exclusivamente por meio da plataforma, através de cartões de crédito, débito ou métodos eletrônicos autorizados. Todas as transações estão sujeitas às nossas políticas internas e às regras das operadoras.
          </p>
          <p className={classes.description}><strong>Conduta do Usuário</strong></p>
          <p className={classes.description}>
            O usuário compromete-se a:<br />
            Utilizar a plataforma de forma ética, lícita e respeitosa;<br />
            Não realizar pedidos fraudulentos ou de má-fé;<br />
            Não utilizar o sistema para fins ilícitos ou abusivos;<br />
            Zelar pela segurança de suas informações de acesso (login e senha).
          </p>
          <p className={classes.description}><strong>Conteúdo Gerado pelo Usuário</strong></p>
          <p className={classes.description}>
            O conteúdo eventualmente submetido pelo usuário (comentários, avaliações, sugestões etc.) permanece de sua titularidade. No entanto, ao enviá-lo, o usuário concede à empresa uma licença não exclusiva, irrevogável e gratuita para uso, publicação, reprodução e adaptação para fins institucionais, comerciais ou de melhoria dos serviços.
          </p>
          <p className={classes.description}><strong>Propriedade Intelectual</strong></p>
          <p className={classes.description}>
            Todo o conteúdo da plataforma, incluindo marcas, software, textos, imagens, logos, ícones e funcionalidades é de titularidade da empresa ou de seus licenciadores, sendo vedada qualquer reprodução, distribuição ou engenharia reversa sem autorização expressa.
          </p>
          <p className={classes.description}><strong>Responsabilidades dos Motoristas e Entregadores</strong></p>
          <p className={classes.description}>
            Os motoristas e entregadores cadastrados na plataforma atuam como prestadores de serviço autônomos. São integralmente responsáveis por:<br />
            Cumprir as leis de trânsito, regulamentos e normas vigentes;<br />
            Manter a documentação pessoal e do veículo atualizadas;<br />
            Garantir boas condições de higiene, segurança e conservação do veículo;<br />
            Tratar os usuários com cordialidade e respeito.<br />
            A empresa não se responsabiliza por atos, omissões, acidentes ou infrações cometidas pelos motoristas ou entregadores durante a prestação do serviço.
          </p>
          <p className={classes.description}><strong>Proteção de Dados e Privacidade (LGPD)</strong></p>
          <p className={classes.description}>
            A coleta, armazenamento e tratamento dos dados pessoais dos usuários serão realizados conforme a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018). Comprometemo-nos a:<br />
            Utilizar os dados apenas para fins legítimos e vinculados à prestação dos serviços;<br />
            Garantir medidas técnicas e administrativas para proteger os dados;<br />
            Não compartilhar os dados com terceiros, salvo nos casos previstos em lei ou com consentimento do usuário;<br />
            Oferecer mecanismos para que o usuário acesse, corrija ou exclua seus dados, mediante requisição.<br />
            O uso da plataforma implica concordância com a nossa Política de Privacidade, que deve ser lida em conjunto com este termo.
          </p>
          <p className={classes.description}><strong>Política de Cancelamento e Reembolso</strong></p>
          <p className={classes.description}>
            Cancelamento pelo usuário: é permitido até o momento anterior ao início do deslocamento do prestador. Após esse ponto, poderá haver cobrança parcial ou total.<br />
            Cancelamento pelo prestador: motoristas ou entregadores que cancelarem corridas sem justificativa estarão sujeitos às penalidades da plataforma.<br />
            Reembolso: em caso de cobrança indevida ou falha na prestação do serviço, o usuário poderá solicitar reembolso através do canal oficial. Cada caso será analisado individualmente, conforme os critérios internos da empresa.
          </p>
          <p className={classes.description}><strong>Isenção de Garantias</strong></p>
          <p className={classes.description}>
            A plataforma é disponibilizada “no estado em que se encontra”, sem garantias de funcionamento contínuo ou livre de erros. A empresa não assegura qualidade, pontualidade ou segurança dos serviços prestados por terceiros.
          </p>
          <p className={classes.description}><strong>Limitação de Responsabilidade</strong></p>
          <p className={classes.description}>
            Em nenhum caso a empresa será responsabilizada por danos indiretos, incidentais, lucros cessantes, perdas de dados ou danos morais decorrentes do uso ou da impossibilidade de uso da plataforma.
          </p>
          <p className={classes.description}><strong>Rescisão</strong></p>
          <p className={classes.description}>
            A empresa poderá, a seu critério exclusivo, suspender ou cancelar a conta do usuário, com ou sem aviso prévio, em caso de descumprimento destes Termos ou por condutas que prejudiquem o funcionamento do serviço ou terceiros.
          </p>
          <p className={classes.description}><strong>Legislação Aplicável e Foro</strong></p>
          <p className={classes.description}>
            Este contrato será regido pelas leis da República Federativa do Brasil. Fica eleito o foro da comarca da sede da empresa como competente para dirimir quaisquer controvérsias, com renúncia expressa a qualquer outro.
          </p>
          <p className={classes.description}><strong>Alterações dos Termos</strong></p>
          <p className={classes.description}>
            Estes Termos poderão ser modificados a qualquer momento. As alterações entrarão em vigor na data de sua publicação. O uso contínuo da plataforma implica concordância com os novos termos.
          </p>
          <p className={classes.description}><strong>Contato</strong></p>
          <p className={classes.description}>
            Em caso de dúvidas, sugestões, reclamações ou solicitações relacionadas a estes Termos ou à LGPD, o usuário poderá entrar em contato pelo seguinte canal:<br />
            E-mail: <a href="mailto:comercial@solutivaassistencia.com.br"><strong>comercial@solutivaassistencia.com.br</strong></a><br />
            Telefone: <strong>19 99804-8854</strong>
          </p>
          <br />
          <br />
        </div>
      </div>
      <Footer />
    </div>
  );
}
